import { render, staticRenderFns } from "./HtmlRenderer.vue?vue&type=template&id=b2f4c4d4&scoped=true"
import script from "./HtmlRenderer.vue?vue&type=script&lang=ts"
export * from "./HtmlRenderer.vue?vue&type=script&lang=ts"
import style0 from "./HtmlRenderer.vue?vue&type=style&index=0&id=b2f4c4d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.41_css-loader@6.11.0_webpack@5.109.2_clean-css_2948e68b94b5de989bd17d5ad2285242/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f4c4d4",
  null
  
)

export default component.exports